
import on_domready from "domready"
import u from "umbrellajs"
import Promise from "plugins/bluebird/index"
import URI from "urijs"

import { isSignedIn, setSignedIn } from "./state"

import { Page } from "app/multi_device"
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"


import I18n from "plugins/i18n-js"


const POST_AUTH_PARTIAL_UPDATE_DATE_ATTRIBUTE_NAME = "post-ajax-auth-partial-update-url"


const signed_callbacks: Array<() => void> = []


const getSignedInPromise = (): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    q_ajax_3({
      url:      `/${I18n.locale}/my/auth_states/signed_in`,
      method:   "GET",
      dataType: "JSON",
    })
    .then(({data, response}) => {
      if (typeof data.signed_in === "undefined"){
        reject(response)
      }

      resolve(data.signed_in)
    })
    .catch(({response}) => {
      reject(response)
    })
    .done()
  })
}

const setAsSignedInAndRefreshComponents = () => {
  // Need to change style
  setSignedIn()

  refreshComponents()
}

function refreshComponents() {
  Promise.all(u(`[data-${POST_AUTH_PARTIAL_UPDATE_DATE_ATTRIBUTE_NAME}]`).nodes.map((el) => {
    const $el = u(el)

    const url_object = URI($el.data(POST_AUTH_PARTIAL_UPDATE_DATE_ATTRIBUTE_NAME))
    if (Page.isForMobile()) {
      url_object.query({is_mobile: "true"})
    }

    return q_ajax_3({
      url:      url_object.toString(),
      method:   "GET",
      dataType: "html",
    })
    .then(({data, response}) => {
      $el.html(data)
    })
  }))
  .then(() => {
    signed_callbacks.forEach((callback) => callback())
  })
}

// Note: Cannot handle from sign in to sign out
// Since we have no AJAX sign out yet
//
// @return boolean [signed_in]
const refreshAndUpdateComponentPromise = (): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    on_domready(() => {
      if (isSignedIn()){
        // No point checking remote state if signed in
        refreshComponents()
        resolve(true)
        return
      }

      getSignedInPromise()
      .then((signed_in) => {
        if (!signed_in){
          // If remote is signed out too then stop
          resolve(false)
          return
        }
        // Local: signed out, remote: signed in
        setAsSignedInAndRefreshComponents()
        resolve(true)
      })
    })
  })
}

const onSignedIn = (callback: () => void): void => {
  if (isSignedIn()){
    callback()
    // Some callbacks must be called after `refreshComponents`
    // So we don't call `return` here
  }

  signed_callbacks.push(callback)
}

export default {
  refreshAndUpdateComponentPromise,
}

export {
  refreshAndUpdateComponentPromise,
  onSignedIn,
}
